import styled from 'styled-components';

import { Container } from '@/components/Grid';

export const PageWrapper = styled.section``;

export const ContainerStyled = styled(Container)`
  display: flex;
  flex-direction: column;
  min-height: 50vh;
  padding: 40px 0;

  text-align: center;
  align-items: center;
  justify-content: center;
`;

export const Layout = styled.section`
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;
`;
